export default "__VITE_ASSET__Dp0iG5Fj__"